import { render, staticRenderFns } from "./ProjectDetailHistoryTab.vue?vue&type=template&id=31eb2be6&"
import script from "./ProjectDetailHistoryTab.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports